<template>
  <div class="condition-wrapper" :class="{'filter-training-users': filterStyle=='trainings'}">
    <div class="tools-container">
        <span class="first-row-add-label" v-if="filterStyle=='trainings'">
            {{toLocal('general.add_users_when')}}
        </span>
        <div class="right-side" v-if="filterStyle=='trainings'">
            <span>
                {{toLocal('groups.users_added')}}: {{user_count}}
            </span>
            <button @click="$emit('viewList')">
                <span>
                    {{toLocal('assign_modal.view_list')}}
                </span>
                <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.4192 6C3.36205 8.8993 6.16939 10.6667 9.23077 10.6667C12.2916 10.6667 15.0927 8.89987 17.042 5.99942C15.0991 3.10046 12.2919 1.33333 9.23077 1.33333C6.16939 1.33333 3.36205 3.1007 1.4192 6ZM0.10343 5.63765C2.23109 2.23614 5.51109 0 9.23077 0C12.9504 0 16.2304 2.23614 18.3581 5.63765C18.4962 5.85845 18.496 6.14267 18.3575 6.36324C16.2233 9.76331 12.951 12 9.23077 12C5.51109 12 2.23109 9.76386 0.10343 6.36235C-0.0344767 6.14187 -0.0344767 5.85813 0.10343 5.63765Z" fill="#4D4D4D"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.23173 4C8.1647 4 7.29971 4.89543 7.29971 6C7.29971 7.10457 8.1647 8 9.23173 8C10.2988 8 11.1637 7.10457 11.1637 6C11.1637 4.89543 10.2988 4 9.23173 4ZM6.01169 6C6.01169 4.15905 7.45335 2.66667 9.23173 2.66667C11.0101 2.66667 12.4518 4.15905 12.4518 6C12.4518 7.84095 11.0101 9.33333 9.23173 9.33333C7.45335 9.33333 6.01169 7.84095 6.01169 6Z" fill="#4D4D4D"/>
                </svg>
            </button>
        </div>
    </div>
    <div class="first-row" :class="{'filter-training-users-row': filterStyle=='trainings'}">
        <span class="first-row-add-label" v-if="filterStyle=='report'">
            {{toLocal('filter.show_when')}}
        </span>
        <span class="first-row-add-label" v-else-if="filterStyle!='trainings'">
            {{toLocal('general.add_when')}}
        </span>
        <div class="dropdown-list-container">
            <div 
                class="filter-item"
                v-for="(column, index) in columns.filter(el=>el.id != 1)"
                :key="index"
                v-show="showDropdown(0, column)"
            >
                <!-- <span v-if="column.id == 8 && showDropdown(0, column)" class="assign-label">
                    {{toLocal('generic.assign')}}
                </span> -->
                <CustomDropdown
                    v-if="!renderFilterInput(0, column) && showDropdown(0, column) && column.inputType == 'dropdown'"
                    :list="getFilterOptions(0, column)"
                    key-label="id"
                    value-label="label"
                    :compare-list="getSelectedItems(0, column.id)"
                    :options="{
                        closeOnClick: filterStyle=='report' ? false : column.id == 4 ? false : true,
                        checkbox: column.multiselect && column.multiselect[0] != undefined ? column.multiselect[0] : column.checkbox,
                        customDDWidth: 'initial',
                        customDDMaxWidth: '250px',
                        customDDMinWidth: '100%',
                        customMaxHeight: 'clamp(8rem, 28vh, 15rem)',
                        initial: getItemPlaceholder(0, column),
                        containerClass: 'condition-filter-dropdown '+getContrast(),
                        searchBar: column.searchBar,
                        left:true,
                        showCreateNewBtn: false,
                        searchLocally: true,
                        valueWidthType: 'dynamic',

                        column: column,
                        selectAllChoice: ['groups', 'week_day', 'workTermStart', 'workTermEnd'].includes(getSelectedColumnValue(0, 2)) ? false : toLocal('users.all_columns'),
                    }"
                    @elClicked="setColumnValue(0, column.id, $event)"
                    @elAll="selectAllColumnValue(0, column.id, $event)"
                >
                    <template v-slot:arrow >
                        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1.5L6 6.5L11 1.5" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </template>
                </CustomDropdown>
                <date-picker
                    v-if="column.id == 4 && getSelectedColumnValue(0, 2) == 'time'"
                    required
                    :value="getSelectedItems(0, column.id) && getSelectedItems(0, column.id)[0] ? getSelectedItems(0, column.id)[0].value : ''"
                    label="date"
                    :placeholder="getSelectedItems(0, column.id) && getSelectedItems(0, column.id)[0] ? getSelectedItems(0, column.id)[0].value : 'Select time'"
                    class="conditional-time-date-picker invitation-date-picker"
                    :show-second="false"
                    format="HH:mm"
                    value-type="format"
                    type="time"
                    @input="setColumnValue(0, column.id, {id:1,value:$event})"
                >
                </date-picker>
                <input
                    type="text"
                    v-if="showDropdown(0, column) && column.inputType == 'input' && getSelectedColumnValue(0, 2) != 'time' && ['training_not_finished','penalty'].includes(getSelectedColumnValue(0, 2))"
                    v-model="textInputs[`0-${column.id}`]"
                    :maxlength="column.maxLength ? column.maxLength : 50"
                    :class="{'short-input': [5,6,7,8,9,11].includes(column.id)}"
                    @input="setFilterTextInput($event, 0, column.id)"
                    @keypress="checkIfInputAllowed($event, 0, column)"
                />
                 <input
                    type="text"
                    v-if="renderFilterInput(0, column) && showDropdown(0, column) && getSelectedColumnValue(0, 2) != 'time'"
                    v-model="textInputs[`0-${column.id}`]"
                    :class="{'short-input': getSelectedColumnValue(0, 2) == 'penalty'}"
                    :maxlength="column.maxLength ? column.maxLength : 50"
                    @input="setFilterTextInput($event, 0, column.id)"
                    @keypress="checkIfInputAllowed($event, 0, column)"
                />
              
            </div>

             <!-- <input
                type="text"
                class="short-input"
                v-if="renderFilterInput(0, column) && showDropdown(0, column) && column.inputType == 'input'"
                v-model="textInputs[`0-4`]"
                @input="setFilterTextInput($event, 0, 4)"
                @keypress="checkIfInputAllowed($event, 0)"
            /> -->
      
            <div class="filter-tag-list" v-if="!showDropdown(0, columns.filter(el=>el.id == 5)[0]) && !showDropdown(0, columns.filter(el=>el.id == 8)[0]) && getSelectedItems(0, 4).length >0 && filterStyle=='trainings'  && !['penalty','time','week_day'].includes(getSelectedColumnValue(0, 2))">
                <div class="hide-box">
                    <div class="fixed-box">
                        <div class="tag" v-for="(item, index) in getSelectedItems(0, 4).slice(0, 5)" :key="`item-${index}`">
                        <span class="text">{{ item.value }}</span>
                        <div class="tag-delete" @click="deleteValue(item, 0, 4)"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.159747 0.159773C0.372754 -0.0532476 0.718116 -0.053259 0.931136 0.159747L11.8373 11.0652C12.0504 11.2782 12.0504 11.6236 11.8374 11.8366C11.6244 12.0496 11.279 12.0496 11.066 11.8366L0.159773 0.931162C-0.0532476 0.718156 -0.053259 0.372793 0.159747 0.159773Z" fill="#7D7D7D"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8402 0.159709C12.0532 0.372694 12.0533 0.718057 11.8403 0.931098L0.934091 11.8402C0.721106 12.0532 0.375743 12.0533 0.162702 11.8403C-0.0503405 11.6273 -0.0503863 11.2819 0.162599 11.0689L11.0688 0.159811C11.2818 -0.0532304 11.6271 -0.0532762 11.8402 0.159709Z" fill="#7D7D7D"/>
                        </svg></div>
                        </div>
                        <div class="more-options" v-if="getSelectedItems(0, 4).length > 5">
                            ...
                        </div>
                    </div>
                </div>
            </div>
            <div class="options" v-if="selectedFilters.length > 1 && filterStyle=='trainings'">
                <div class="option-btn" @click="copyFilterRow(0)"> 
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="4.5" width="14.9986" height="14.9986" rx="1.5" fill="#F4F4F4" stroke="#4D4D4D"/>
                        <rect x="4.5" y="0.5" width="14.9986" height="14.9986" rx="1.5" fill="#F4F4F4" stroke="#4D4D4D"/>
                    </svg>
                </div>
                <div class="option-btn" @click="removeFilterRow(0)">
                    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">                    <path d="M10.2008 20H5.68728C3.33325 20 1.4202 18.1168 1.4202 15.7995V3.95145H14.4679V15.7932C14.4679 18.1104 12.5548 19.9936 10.2008 19.9936V20ZM2.39294 15.7995C2.39294 17.587 3.8715 19.0424 5.68728 19.0424H10.2008C12.0166 19.0424 13.4951 17.587 13.4951 15.7995V4.90901H2.39294V15.7995Z" fill="#D45454"/>                    <path d="M14.3317 4.92183C14.2798 4.92183 14.2214 4.92183 14.1696 4.91545H1.67959C1.23213 4.91545 0.810614 4.74309 0.492853 4.43668C0.175092 4.12388 0 3.70894 0 3.26846C0 2.36198 0.752249 1.62148 1.67311 1.62148H14.2149C14.2603 1.62148 14.3317 1.62148 14.4095 1.62148H14.4808C15.4082 1.71723 16.0826 2.52157 15.9918 3.42806C15.9464 3.86853 15.7324 4.26432 15.3887 4.5452C15.0839 4.79416 14.7143 4.92183 14.3252 4.92183H14.3317ZM1.67311 2.57903C1.28401 2.57903 0.972735 2.88544 0.972735 3.26846C0.972735 3.45359 1.04407 3.62595 1.18025 3.76001C1.31644 3.89406 1.49153 3.96428 1.67959 3.96428H14.2214C14.4614 3.98344 14.6365 3.92598 14.7856 3.81108C14.9283 3.68979 15.0191 3.52381 15.0385 3.34507C15.0774 2.96205 14.7921 2.62371 14.403 2.58541C14.3187 2.58541 14.2863 2.58541 14.2539 2.58541H1.67959L1.67311 2.57903Z" fill="#D45454"/>                    <path d="M10.8752 2.57262H5.00637L4.88316 2.27259C4.80534 2.07469 4.75995 1.86403 4.75995 1.65337C4.75995 0.74689 5.5122 0.00638367 6.43306 0H9.43558C10.3629 0 11.1152 0.740506 11.1152 1.65337C11.1152 1.86403 11.0763 2.07469 10.9984 2.27259L10.8752 2.57262ZM5.73917 1.61507H10.1424C10.123 1.2512 9.8117 0.957551 9.44206 0.957551H6.43954C6.0699 0.957551 5.75863 1.2512 5.73917 1.61507Z" fill="#D45454"/>                    <path d="M5.01283 16.7955C4.74695 16.7955 4.52646 16.5784 4.52646 16.3167V6.888C4.52646 6.62627 4.74695 6.40923 5.01283 6.40923C5.27871 6.40923 5.4992 6.62627 5.4992 6.888V16.3167C5.4992 16.5784 5.27871 16.7955 5.01283 16.7955Z" fill="#D45454"/>                    <path d="M7.94401 16.7955C7.67813 16.7955 7.45764 16.5784 7.45764 16.3167V6.888C7.45764 6.62627 7.67813 6.40923 7.94401 6.40923C8.20989 6.40923 8.43038 6.62627 8.43038 6.888V16.3167C8.43038 16.5784 8.20989 16.7955 7.94401 16.7955Z" fill="#D45454"/>                    <path d="M10.8752 16.7955C10.6093 16.7955 10.3888 16.5784 10.3888 16.3167V6.888C10.3888 6.62627 10.6093 6.40923 10.8752 6.40923C11.1411 6.40923 11.3616 6.62627 11.3616 6.888V16.3167C11.3616 16.5784 11.1411 16.7955 10.8752 16.7955Z" fill="#D45454"/>                    </svg>
                </div>
            </div>
            <svg v-if="selectedFilters.length > 1 && filterStyle!='trainings'" class="remove-filter-btn" @click="removeFilterRow(0)" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.219653 0.470943C0.512536 0.17804 0.98741 0.178024 1.28031 0.470908L11.2777 10.4676C11.5706 10.7605 11.5706 11.2354 11.2777 11.5283C10.9848 11.8212 10.5099 11.8212 10.217 11.5283L0.219687 1.5316C-0.0732155 1.23872 -0.0732311 0.763846 0.219653 0.470943Z" fill="#7D7D7D"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2803 0.4696C11.5732 0.762454 11.5733 1.23733 11.2804 1.53026L1.28305 11.5303C0.990196 11.8232 0.515323 11.8233 0.222391 11.5304C-0.0705414 11.2375 -0.0706043 10.7627 0.22225 10.4697L10.2196 0.46974C10.5125 0.176808 10.9873 0.176745 11.2803 0.4696Z" fill="#7D7D7D"/>
            </svg>
        </div>
        <div v-if="filterStyle=='trainings' && getSelectedColumnValue(0, 2) == 'penalty'" class="checkbox-container">
            <CheckBox 
                id="tableBox" 
                :value="getSelectedColumnItemValue(0, 2, 'autoAssign')"
                @input="setSelectedColumnValue($event, 0, 2, 'autoAssign')"
                label="Automatinis pakartotinis priskyrimas"
            />
        </div>
    </div>
    <div class="additional-row-container">
        <div class="additional-row"  v-for="(filter, row_index) in selectedFilters.slice(1)" :key="row_index" :class="{'filter-training-users-row': filterStyle=='trainings'}">
            <div class="dropdown-list-container">
                <div 
                    class="filter-item"
                    v-for="(column, index) in columns"
                    v-show="showDropdown(row_index+1, column)"
                    :key="index"
                >
                    <!-- <span v-if="column.id == 8 && showDropdown(row_index+1, column)" class="assign-label">
                        {{toLocal('generic.assign')}}
                    </span> -->
                    <CustomDropdown
                        v-if="!renderFilterInput(row_index+1, column) && showDropdown(row_index+1, column) && column.inputType == 'dropdown'"
                        :list="getFilterOptions(row_index+1, column)"
                        key-label="id"
                        value-label="label"
                        :compare-list="getSelectedItems(row_index+1, column.id)"
                        :options="{
                            closeOnClick: filterStyle=='report' ? false : column.id == 4 ? false : true,
                            checkbox: column.multiselect && column.multiselect[row_index+1] != undefined ? column.multiselect[row_index+1] : column.checkbox,
                            customDDWidth: 'initial',
                            customDDMaxWidth: '250px',
                            customDDMinWidth: '100%',
                            customMaxHeight: '300px',
                            initial: getItemPlaceholder(row_index+1, column),
                            containerClass: 'condition-filter-dropdown '+getContrast(),
                            searchBar: column.searchBar,
                            left:true,
                            showCreateNewBtn: false,
                            searchLocally: true,
                            valueWidthType: 'dynamic',

                            column: column,
                            selectAllChoice: ['groups', 'week_day', 'workTermStart', 'workTermEnd'].includes(getSelectedColumnValue(row_index+1, 2)) ? false : toLocal('users.all_columns'),
                        }"
                        :class="{'logical-condition': column.type == 'logic' }"
                        @elClicked="setColumnValue(row_index+1, column.id, $event)"
                    >
                        <template v-slot:arrow >
                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1.5L6 6.5L11 1.5" stroke="#333333" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </template>
                    </CustomDropdown>
                     <date-picker
                        v-if="column.id == 4 && getSelectedColumnValue(row_index+1, 2) == 'time'"
                        required
                        :value="getSelectedItems(row_index+1, column.id) && getSelectedItems(row_index+1, column.id)[0] ? getSelectedItems(row_index+1, column.id)[0].value : ''"
                        label="date"
                        :placeholder="getSelectedItems(row_index+1, column.id) && getSelectedItems(row_index+1, column.id)[0] ? getSelectedItems(row_index+1, column.id)[0].value : 'Select time'"
                        class="conditional-time-date-picker invitation-date-picker"
                        :show-second="false"
                        format="HH:mm"
                        value-type="format"
                        type="time"
                        @input="setColumnValue(row_index+1, column.id, {id:1,value:$event})"
                    >
                </date-picker>
                    <input
                        type="text"
                        v-if="showDropdown(row_index+1, column) && column.inputType == 'input' && getSelectedColumnValue(row_index+1, 2) != 'time' && ['training_not_finished','penalty'].includes(getSelectedColumnValue(row_index+1, 2))"
                        v-model="textInputs[`${row_index+1}-${column.id}`]"
                        :maxlength="column.maxLength ? column.maxLength : 50"
                        :class="{'short-input': [5,6,7,8,9,11].includes(column.id)}"
                        @input="setFilterTextInput($event, row_index+1, column.id)"
                        @keypress="checkIfInputAllowed($event, row_index+1, column)"
                    />
                    <input
                        type="text"
                        v-if="renderFilterInput(row_index+1, column) && showDropdown(row_index+1, column) && getSelectedColumnValue(row_index+1, 2) != 'time'"
                        v-model="textInputs[`${row_index+1}-${column.id}`]"
                        :class="{'short-input': getSelectedColumnValue(0, 2) == 'penalty'}"
                        :maxlength="column.maxLength ? column.maxLength : 50"
                        @input="setFilterTextInput($event, row_index+1, column.id)"
                        @keypress="checkIfInputAllowed($event, row_index+1, column)"
                    />
                
                    
                </div>

                <div class="filter-tag-list" v-if="!showDropdown(row_index, columns.filter(el=>el.id == 5)[0]) && !showDropdown(0, columns.filter(el=>el.id == 8)[0]) && getSelectedItems(row_index+1, 4).length >0 && filterStyle=='trainings' && !['time','week_day'].includes(getSelectedColumnValue(row_index+1, 2))">
                    <div class="hide-box">
                        <div class="fixed-box">
                            <div class="tag" v-for="(item, index) in getSelectedItems(row_index+1, 4).slice(0, 5)" :key="`item-${index}`">
                            <span class="text">{{ item.value }}</span>
                            <div class="tag-delete" @click="deleteValue(item, row_index+1, 4)"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.159747 0.159773C0.372754 -0.0532476 0.718116 -0.053259 0.931136 0.159747L11.8373 11.0652C12.0504 11.2782 12.0504 11.6236 11.8374 11.8366C11.6244 12.0496 11.279 12.0496 11.066 11.8366L0.159773 0.931162C-0.0532476 0.718156 -0.053259 0.372793 0.159747 0.159773Z" fill="#7D7D7D"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8402 0.159709C12.0532 0.372694 12.0533 0.718057 11.8403 0.931098L0.934091 11.8402C0.721106 12.0532 0.375743 12.0533 0.162702 11.8403C-0.0503405 11.6273 -0.0503863 11.2819 0.162599 11.0689L11.0688 0.159811C11.2818 -0.0532304 11.6271 -0.0532762 11.8402 0.159709Z" fill="#7D7D7D"/>
                            </svg></div>
                            </div>
                            <div class="more-options" v-if="getSelectedItems(row_index+1, 4).length > 5">
                                ...
                            </div>
                        </div>
                    </div>
                </div>
                <div class="options" v-if="filterStyle=='trainings'">
                    <div class="option-btn" @click="copyFilterRow(row_index+1)"> 
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="4.5" width="14.9986" height="14.9986" rx="1.5" fill="#F4F4F4" stroke="#4D4D4D"/>
                            <rect x="4.5" y="0.5" width="14.9986" height="14.9986" rx="1.5" fill="#F4F4F4" stroke="#4D4D4D"/>
                        </svg>
                    </div>
                    <div class="option-btn" @click="removeFilterRow(row_index+1)" >
                        <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">                    <path d="M10.2008 20H5.68728C3.33325 20 1.4202 18.1168 1.4202 15.7995V3.95145H14.4679V15.7932C14.4679 18.1104 12.5548 19.9936 10.2008 19.9936V20ZM2.39294 15.7995C2.39294 17.587 3.8715 19.0424 5.68728 19.0424H10.2008C12.0166 19.0424 13.4951 17.587 13.4951 15.7995V4.90901H2.39294V15.7995Z" fill="#D45454"/>                    <path d="M14.3317 4.92183C14.2798 4.92183 14.2214 4.92183 14.1696 4.91545H1.67959C1.23213 4.91545 0.810614 4.74309 0.492853 4.43668C0.175092 4.12388 0 3.70894 0 3.26846C0 2.36198 0.752249 1.62148 1.67311 1.62148H14.2149C14.2603 1.62148 14.3317 1.62148 14.4095 1.62148H14.4808C15.4082 1.71723 16.0826 2.52157 15.9918 3.42806C15.9464 3.86853 15.7324 4.26432 15.3887 4.5452C15.0839 4.79416 14.7143 4.92183 14.3252 4.92183H14.3317ZM1.67311 2.57903C1.28401 2.57903 0.972735 2.88544 0.972735 3.26846C0.972735 3.45359 1.04407 3.62595 1.18025 3.76001C1.31644 3.89406 1.49153 3.96428 1.67959 3.96428H14.2214C14.4614 3.98344 14.6365 3.92598 14.7856 3.81108C14.9283 3.68979 15.0191 3.52381 15.0385 3.34507C15.0774 2.96205 14.7921 2.62371 14.403 2.58541C14.3187 2.58541 14.2863 2.58541 14.2539 2.58541H1.67959L1.67311 2.57903Z" fill="#D45454"/>                    <path d="M10.8752 2.57262H5.00637L4.88316 2.27259C4.80534 2.07469 4.75995 1.86403 4.75995 1.65337C4.75995 0.74689 5.5122 0.00638367 6.43306 0H9.43558C10.3629 0 11.1152 0.740506 11.1152 1.65337C11.1152 1.86403 11.0763 2.07469 10.9984 2.27259L10.8752 2.57262ZM5.73917 1.61507H10.1424C10.123 1.2512 9.8117 0.957551 9.44206 0.957551H6.43954C6.0699 0.957551 5.75863 1.2512 5.73917 1.61507Z" fill="#D45454"/>                    <path d="M5.01283 16.7955C4.74695 16.7955 4.52646 16.5784 4.52646 16.3167V6.888C4.52646 6.62627 4.74695 6.40923 5.01283 6.40923C5.27871 6.40923 5.4992 6.62627 5.4992 6.888V16.3167C5.4992 16.5784 5.27871 16.7955 5.01283 16.7955Z" fill="#D45454"/>                    <path d="M7.94401 16.7955C7.67813 16.7955 7.45764 16.5784 7.45764 16.3167V6.888C7.45764 6.62627 7.67813 6.40923 7.94401 6.40923C8.20989 6.40923 8.43038 6.62627 8.43038 6.888V16.3167C8.43038 16.5784 8.20989 16.7955 7.94401 16.7955Z" fill="#D45454"/>                    <path d="M10.8752 16.7955C10.6093 16.7955 10.3888 16.5784 10.3888 16.3167V6.888C10.3888 6.62627 10.6093 6.40923 10.8752 6.40923C11.1411 6.40923 11.3616 6.62627 11.3616 6.888V16.3167C11.3616 16.5784 11.1411 16.7955 10.8752 16.7955Z" fill="#D45454"/>                    </svg>
                    </div>
                </div>
                <svg class="remove-filter-btn" @click="removeFilterRow(row_index+1)" v-if="filterStyle!='trainings'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.219653 0.470943C0.512536 0.17804 0.98741 0.178024 1.28031 0.470908L11.2777 10.4676C11.5706 10.7605 11.5706 11.2354 11.2777 11.5283C10.9848 11.8212 10.5099 11.8212 10.217 11.5283L0.219687 1.5316C-0.0732155 1.23872 -0.0732311 0.763846 0.219653 0.470943Z" fill="#7D7D7D"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2803 0.4696C11.5732 0.762454 11.5733 1.23733 11.2804 1.53026L1.28305 11.5303C0.990196 11.8232 0.515323 11.8233 0.222391 11.5304C-0.0705414 11.2375 -0.0706043 10.7627 0.22225 10.4697L10.2196 0.46974C10.5125 0.176808 10.9873 0.176745 11.2803 0.4696Z" fill="#7D7D7D"/>
                </svg>

            </div>
            <div v-if="filterStyle=='trainings' && getSelectedColumnValue(row_index+1, 2) == 'penalty'" class="checkbox-container">
                <CheckBox 
                    id="tableBox" 
                    :value="getSelectedColumnItemValue(row_index+1, 2, 'autoAssign')"
                    @input="setSelectedColumnValue($event, row_index+1, 2, 'autoAssign')"
                    label="Automatinis pakartotinis priskyrimas"
                />
            </div>
        </div>
    </div>
    <span class="add-new-row" :class="{'white-btn': filterStyle=='report'}" @click="addNewFilterRow">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.99908C10 5.22337 9.81819 5.40521 9.59389 5.40521L5.40469 5.40535L5.40524 9.59382C5.40527 9.81812 5.22347 9.99997 4.99917 10C4.77488 10 4.59303 9.81823 4.593 9.59393L4.59244 5.40538L0.406138 5.40551C0.181841 5.40552 7.62797e-06 5.2237 2.18211e-10 4.9994C-7.27378e-06 4.77511 0.181815 4.59327 0.406111 4.59327L4.59233 4.59313L4.59178 0.406178C4.59175 0.181882 4.77355 2.97249e-05 4.99785 3.64898e-09C5.22214 -2.97404e-05 5.404 0.181774 5.40403 0.40607L5.40458 4.5931L9.59386 4.59296C9.81816 4.59296 9.99999 4.77478 10 4.99908Z" fill="#7D7D7D"/>
        </svg>
        {{toLocal('groups.add_row')}}
    </span>
  </div>
</template>

<script>
import CustomDropdown from "@/components/layout/elements/CustomDropdown.vue";
import axios from 'axios';
import CheckBox from '@/components/layout/inputs/CheckBox'
import DatePicker from "vue2-datepicker";

export default {
    props:{
        group: Object,
        level: Number,
        groupUserFilter: Array,
        groups: Array,
        user_data: Array,
        includable_columns: Array,
        filterStyle: String,
        selectedFilter: Array,
        user_count: Number,
        initial_cols: Array,
        options: Object
    },
    components:{
        CheckBox,
        CustomDropdown,
        DatePicker
    },
    watch:{
        selectedFilters:{
            deep:true,
            handler(){
                this.$emit('filterEvent', this.selectedFilters)
            }
        },
        includable_columns:{
            immediate:true,
            handler() {
                if (this.includable_columns) {
                    let index = this.columns.findIndex(el => el.type == 'key');
                    if (index != -1) {
                        this.includable_columns.forEach(col => {
                            let option_index = this.columns[index].options.findIndex(el => el.value == col);
                            if (option_index == -1) {
                                let label = this.toLocal('cols.' + col);
                                if(col == 'name'){
                                    label = this.toLocal('cols.' + col)+' '+this.toLocal('cols.last_name');
                                    col = 'full_name'
                                }
                                if(col != 'last_name'){
                                    this.columns[index].options.push({
                                        id: this.columns[index].options.length + 1,
                                        type: 'text',
                                        label: label,
                                        value: col
                                    })
                                }
                            }
                        });
                        if(this.filterStyle == 'trainings'){
                            this.additionalKeyColums.forEach(col => {
                                let option_index = this.columns[index].options.findIndex(el => el.value == col.value);
                                if (option_index == -1) {
                                    let label = this.toLocal(col.label);
                                    this.columns[index].options.push({
                                        id: this.columns[index].options.length + 1,
                                        type: col.type,
                                        label: label,
                                        value: col.value
                                    })
                                }
                            });
                        }
                    }
                }
            }
        },
        initial_cols: {
            immediate: true,
            handler(){
                let index = this.columns.findIndex(el => el.type == 'key');
                if (index != -1 && this.initial_cols && this.initial_cols.length > 0) {
                    this.initial_cols.forEach(col => {
                        let option_index = this.columns[index].options.findIndex(el => el.value == col.value);
                        if (option_index == -1) {
                            let label = this.toLocal(col.label);
                            let new_obj = {
                                id: this.columns[index].options.length + 1,
                                type: col.type,
                                label: label,
                                value: col.value
                            };
                            if (col.additional) {
                                new_obj.additional = col.additional;
                            }
                            if (col.conditions) {
                                new_obj.conditions = col.conditions;
                            }
                            this.columns[index].options.push(new_obj)
                        }
                    });
                    this.additionalKeyColums.forEach(col => {
                        let option_index = this.columns[index].options.findIndex(el => el.value == col.value);
                        if (option_index == -1) {
                            let label = this.toLocal(col.label);
                            this.columns[index].options.push({
                                id: this.columns[index].options.length + 1,
                                type: col.type,
                                label: label,
                                value: col.value
                            })
                        }
                    });
             
                   
                }
            }
        },
        groupUserFilter:{
            immediate: true,
            handler(){
                if(this.groupUserFilter && this.groupUserFilter.length > 0){
                    let filter = this.groupUserFilter;
                    this.selectedFilters = filter;
                    this.$nextTick(el=>{
                        filter.forEach((el, i) => {
                            if(this.renderFilterInput(i, this.columns.filter(el=>el.id == 4)[0])){
                                let col_index = el.cols.findIndex(el=>el.id == 4);
                                if(col_index != -1){
                                    this.textInputs[i] = el.cols[col_index].selectedOption[0].value
                                }
                            }
                            el.cols.forEach((col,col_index) => {
                                if(col.id == 2){
                                    let selectedOption = col.selectedOption[0];
                                    this.setValueColumnOptions(i,selectedOption, false)
                                }
                            })
                        
                        });
                    })
                }
            }
        }
    },
   
    data(){
        return{
            columns:[
                {
                    id: 1,
                    type: 'logic',
                    closeOnClick:true,
                    inputType: 'dropdown',
                    options: [
                        {id: 1, label: this.toLocal('general.and'), value: 'and'},
                        {id: 2, label: this.toLocal('training_edit.test_questions_or'), value: 'or'},
                        {id: 3, label: this.toLocal('general.but_not'), value: 'not'},
                    ],
                },
                {
                    id: 2,
                    type: 'key',
                    placeholder: this.toLocal('general.column_name'),
                    checkbox: false,
                    inputType: 'dropdown',
                    closeOnClick:true,
                    options: [
                       
                    ],
                },
                {
                    id: 3,
                    type: 'condition',
                    checkbox: false,
                    closeOnClick:true,
                    inputType: 'dropdown',
                    placeholder: this.toLocal('general.condition'),
                    options: [
                        {id: 1, label: this.toLocal('general.is'), value: 'is', type:'text'},
                        {id: 2, label: this.toLocal('general.is_not'), value: 'is not', type:'text'},
                        {id: 3, label: this.toLocal('general.includes'), value: 'includes', type:'text'},
                        {id: 4, label: this.toLocal('general.excludes'), value: 'excludes', type:'text'},
                        {id: 5, label: '=', value: '=', type:'number'},
                        {id: 6, label: '≠', value: '!=', type:'number'},
                        {id: 7, label: '≥', value: '>=', type:'number'},
                        {id: 8, label: '>', value: '>', type:'number'},
                        {id: 9, label: '≤', value: '<=', type:'number'},
                        {id: 10, label: '<', value: '<', type:'number'},
                    ],
                },
                {
                    id: 4,
                    type: 'value',
                    checkbox: true,
                    closeOnClick:false,
                    inputType: 'dropdown',
                    placeholder: this.toLocal('general.column_values'),
                    searchBar: true,
                    options: [
                    
                    ],
                },
                {
                    id: 5,
                    type: 'timeframe_type',
                    checkbox: false,
                    closeOnClick:true,
                    placeholder: this.toLocal('mail.each'),
                    searchBar: false,
                    inputType: 'dropdown',
                    options: [
                        {id: 1, label: this.toLocal('mail.each'), value: 'in_timeframe'},
                        {id: 2, label: this.toLocal('email.template_static_time_type_2'), value: 'now'},
                    ],
                },
                {
                    id: 6,
                    type: 'timeframe_text',
                    checkbox: false,
                    closeOnClick:true,
                    placeholder: 'per',
                    inputType: 'input',
                    inputFormat: 'number',
                    maxLength: 4,
                    searchBar: false,
                    options: [
                    ],
                },
                {
                    id: 7,
                    type: 'timeframe_period',
                    checkbox: false,
                    closeOnClick:true,
                    placeholder: this.toLocal('generic.days_multiple'),
                    inputType: 'dropdown',
                    searchBar: false,
                    options: this.options ? this.options.timeframeOptions : [],
                },
                // {
                //     id: 8,
                //     type: 'assign_timing',
                //     checkbox: false,
                //     closeOnClick:true,
                //     placeholder: this.toLocal('mail.after'),
                //     searchBar: false,
                //     inputType: 'dropdown',
                //     options: [
                //         {id: 1, label: this.toLocal('mail.after'), value: 'after'},
                //         {id: 2, label: this.toLocal('email.template_static_time_type_2'), value: 'now'},
                //     ],
                // },
                // {
                //     id: 9,
                //     type: 'assign_timing_text',
                //     checkbox: false,
                //     closeOnClick:true,
                //     placeholder: '',
                //     inputType: 'input',
                //     inputFormat: 'number',
                //     maxLength: 4,
                //     searchBar: false,
                //     options: [],
                // },
                // {
                //     id: 10,
                //     type: 'assign_timing_period',
                //     checkbox: false,
                //     closeOnClick:true,
                //     placeholder: 'Days',
                //     inputType: 'dropdown',
                //     searchBar: false,
                //     options: this.options ? this.options.timeframeOptions : [],
                // },
                {
                    id: 11,
                    type: 'additional_value',
                    checkbox: false,
                    closeOnClick:true,
                    placeholder: 'Value',
                    inputType: 'input',
                    searchBar: false,
                    options: [],
                }

                
            ],
            additionalKeyColums: [
                {
                    id: 99,
                    type: 'text',
                    label: 'menu.groups',
                    value: 'groups',
                },
                {
                    id: 100,
                    type: 'text',
                    label: 'trainings.training_not_done',
                    value: 'training_not_finished',
                },
                {
                    id: 101,
                    type: 'text',
                    label: 'generic.penalty',
                    value: 'penalty',
                },
                {
                    id: 102,
                    type: 'text',
                    label: 'generic.week_day',
                    value: 'week_day',
                },
                {
                    id: 103,
                    type: 'text',
                    label: 'generic.time',
                    value: 'time',
                },
            ],
            selectedFilters: [
                {
                    cols: [
                        {id:3, selectedOption:[{id: 1, label: this.toLocal('general.is'), value: 'is', type:'text'}], type: 'condition'},
                    ],
                }
            ],
            trainings: [],
            violations:[],
            textInputs: {},
            weekDays: [{
                id: 1,
                label: this.toLocal('general.monday'),
                value: 1,
            },
            {
                id: 2,
                label: this.toLocal('general.tuesday'),
                value: 2,
            },
            {
                id: 3,
                label: this.toLocal('general.wednesday'),
                value: 3,
            },
            {
                id: 4,
                label: this.toLocal('general.thursday'),
                value: 4,
            },
            {
                id: 5,
                label: this.toLocal('general.friday'),
                value: 5,
            },
            {
                id: 6,
                label: this.toLocal('general.saturday'),
                value: 6,
            },
            {
                id: 7,
                label: this.toLocal('general.sunday'),
                value: 7,
            }
            ]

        }
    },
    mounted(){
        if(this.selectedFilter  && this.selectedFilter.length > 0){
            this.selectedFilters = this._.cloneDeep(this.selectedFilter);
            this.selectedFilters.forEach((row, row_index) => {
                let first_key_col = row.cols.find(el=>el.type == 'key');
                if(first_key_col){
                    this.getFilterData(row_index, true);
                }
                let value_index = row.cols.findIndex(el => el.type == 'value');
                if(value_index != -1)
                    this.textInputs[`${row_index}-4`] = row.cols[value_index].selectedOption[0].value
                let input_cols = this.columns.filter(el => el.inputType == 'input');
                if(input_cols.length > 0){
                    input_cols.forEach((col)=>{
                        let col_index = row.cols.findIndex(el => el.id == col.id);
                        if(col_index != -1){
                            this.textInputs[`${row_index}-${col.id}`] = row.cols[col_index].selectedOption[0].value
                        }
                    })
                }
            });
        }
      
    },
    methods:{
        deleteValue(item, row, column){
            let filter_index = this.selectedFilters[row].cols.findIndex((el)=>{return el.id === column});

            let removeIndex = this.selectedFilters[row].cols[filter_index].selectedOption.findIndex((opt)=>{
                        return opt.id == item.id
                    });
                    if(removeIndex !== -1){
                        this.selectedFilters[row].cols[filter_index].selectedOption.splice(removeIndex,1)
                        if(this.selectedFilters[row].cols[filter_index].selectedOption.length == 0){
                            this.selectedFilters[row].cols.splice(filter_index, 1)
                        }
        }
        },
        selectAllColumnValue(row_index, id){
            let index = this.columns.findIndex(el => el.id == id);
            let options = this.columns[index].options

            if(this.columns[index].id == 4){
                options = options[row_index];
            }
            
            options.forEach((entry)=>{
                this.setColumnValue(row_index, id, entry.value);
            })
        },
        getSelectedColumnValue(row_index, column_id, key='value'){
            let filter_index = this.selectedFilters[row_index].cols.findIndex(el=>el.id == column_id);
            if (filter_index != -1) {
                return this.selectedFilters[row_index].cols[filter_index].selectedOption[0][key];
            }
            return ''
        },
         getSelectedColumnItemValue(row_index, column_id, key='value'){
            let filter_index = this.selectedFilters[row_index].cols.findIndex(el=>el.id == column_id);
            if (filter_index != -1) {
                if(key == 'autoAssign'){
                    return this.selectedFilters[row_index].cols[filter_index] && this.selectedFilters[row_index].cols[filter_index][key] ? this.selectedFilters[row_index].cols[filter_index][key] : false;
                }
                return this.selectedFilters[row_index].cols[filter_index][key];
            }
            return ''
        },
        setSelectedColumnValue(value, row_index, column_id, key='value'){
            let filter_index = this.selectedFilters[row_index].cols.findIndex(el=>el.id == column_id);
            if (filter_index != -1) {
                this.selectedFilters[row_index].cols[filter_index][key] = value;
            }
            else{
                 this.selectedFilters[row_index].cols.push({
                    id: id,
                    type: this.columns[index].type,
                    [key]: value
                })
            }
            return ''
        },
        setColumnValue(row_index, id, value){
            let index = this.columns.findIndex(el => el.id == id);
            let options = this.columns[index].options
            if(!this.selectedFilters[row_index].cols) this.selectedFilters[row_index].cols = [];
            let filter_index = this.selectedFilters[row_index].cols.findIndex(el=>el.id == id);
            if(this.columns[index].id == 4){
                if(this.getSelectedColumnValue(row_index, 2) == 'time'){
                    if (filter_index === -1) {
                        this.selectedFilters[row_index].cols.push({
                            id: id,
                            type: this.columns[index].type,
                            selectedOption: [value]
                        })
                    }
                    else{
                        this.selectedFilters[row_index].cols[filter_index].selectedOption = [value];
                    }
                    return
                }
                options = options[row_index];
            }
            let options_index = options.findIndex(el=>el.id == value)
          
            let selectedOption = {};
            if(options_index == -1){
                selectedOption = value;
            }
            else{
                if(this.columns[index].id == 4){
                    selectedOption = this.columns[index].options[row_index][options_index];
                }
                else{
                    selectedOption = this.columns[index].options[options_index];
                }
            }
            if (filter_index === -1) {
                
                this.selectedFilters[row_index].cols.push({
                    id: id,
                    type: this.columns[index].type,
                    selectedOption: [selectedOption]
                })
            }
            else{
                if (this.columns[index].id == 4) {
                    if(this.columns[index].multiselect && this.columns[index].multiselect[row_index] != undefined && !this.columns[index].multiselect[row_index]){
                        this.selectedFilters[row_index].cols[filter_index].selectedOption = [selectedOption]
                    }
                    else {
                        let removeIndex = this.selectedFilters[row_index].cols[filter_index].selectedOption.findIndex((opt)=>{
                            return opt.id == selectedOption.id
                        });
                        if(removeIndex !== -1){
                            this.selectedFilters[row_index].cols[filter_index].selectedOption.splice(removeIndex,1)
                            if(this.selectedFilters[row_index].cols[filter_index].selectedOption.length == 0){
                                this.selectedFilters[row_index].cols.splice(filter_index, 1)
                            }
                        }else{
                            this.selectedFilters[row_index].cols[filter_index].selectedOption.push(selectedOption);
                        }
                    }
                }else{
                    this.selectedFilters[row_index].cols[filter_index].selectedOption = [selectedOption]
                }
            }
            if(this.columns[index].id == 2){
                this.setValueColumnOptions(row_index,selectedOption)
            }
        },
        setColumnSubValue(row_index, id, type_key, value) {
            let index = this.columns.findIndex(el => el.id == id);
            let filter_index = this.selectedFilters[row_index].cols.findIndex(el => el.id == id);
            let selectedOption = {};
            let options = this.options[type_key];
            let selected_value_index = options.findIndex(el => el.id == value);
            if (selected_value_index != -1) {
                if (filter_index === -1) {
                    this.selectedFilters[row_index].cols.push({
                        id: id,
                        type: this.columns[index].type,
                        selectedSubOption: [options[selected_value_index]],
                        selectedOption: []
                    })
                }
                if(filter_index != -1)
                    this.$set(this.selectedFilters[row_index].cols[filter_index],'selectedSubOption', [options[selected_value_index]])
                
            }
        },
        async setValueColumnOptions(row_index, selectedOption, user_action=true) {
            if (this.filterStyle == 'report') {
                await this.getFilterData(row_index, false);
                return;
            }
            let option = selectedOption.value;
            let value_index = this.columns.findIndex(el=>el.type == 'value');
            let user_data_copy = this._.cloneDeep(this.user_data);
            let mapped_users = user_data_copy.filter(user=>{
                if(option == 'full_name'){
                    user.full_name = user.first_name + ' ' + user.last_name
                }
                return user[option] && user[option] != null
            });
            if (option == 'hierarchy_nodes') {
                let options = []
                mapped_users.forEach(user => {
                    user[option].forEach(node => {
                        if (!options.find(opt => opt.id == node.id)) {
                            options.push({
                                id: node.id,
                                label: node.name,
                                value: node.name
                            })
                        }
                    })
                });
                mapped_users = options
            }
            else if(option == 'week_day'){
                mapped_users = this.weekDays;
            }
             else if(option == 'time'){
                mapped_users = [];
            }
            else if(option == 'groups' && this.groups && this.groups.length > 0){
                mapped_users = this.groups.filter(el=>{
                    return el.id != 0
                });
                mapped_users = mapped_users.map(el=>{
                    return {
                        id: el.id,
                        label: el.name,
                        value: el.name
                    };
                });
            }
            else if(option == 'training_not_finished'){
                if(this.trainings.length == 0 || this.columns[value_index].options[row_index].length == 0)
                    await this.loadAllTrainings();
             
                mapped_users = this.trainings.map(el=>{
                    return {
                        id: el.id,
                        label: el.title,
                        value: el.id
                    };
                });
            }
            else if(option == 'penalty'){
                if(this.violations.length == 0 || this.columns[value_index].options[row_index].length == 0)
                    await this.loadViolationTypes();
             
                mapped_users = this.violations.map(el=>{
                    return {
                        id: el.type,
                        label: el.type,
                        value: el.type
                    };
                });
            }
            else if(option == 'workTermStart'){
                
             
                mapped_users = [{
                    id: 1,
                    label: this.toLocal('generic.work_term_started'),
                    value: 'started'
                }];
            }
            else if(option == 'user_groups'){
                mapped_users = this.user_data.filter(el=>{
                    return el.user_groups && el.user_groups.length > 0
                });
                mapped_users = mapped_users.map(el=>{
                    return {
                        id: el.id,
                        label: el.name,
                        value: el.name
                    };
                });
            }
            else if(option == 'user_trainings'){
                mapped_users = this.user_data.filter(el=>{
                    return el.user_trainings && el.user_trainings.length > 0
                });
                mapped_users = mapped_users.map(el=>{
                    return {
                        id: el.id,
                        label: el.name,
                        value: el.name
                    };
                });
            }
            else {
                mapped_users = mapped_users.filter(
                    (obj, index) =>
                        mapped_users.findIndex((item) => {
                            if(option == 'full_name'){
                                let a = item['name'] + ' ' + item['last_name'];
                                let b = obj['name'] + ' ' + obj['last_name'];
                                return a === b
                            }
                            return item[option] === obj[option]
                        }) === index
                );
                mapped_users = mapped_users.map(el=>{
                    let label = el[option];
                    if(option == 'full_name'){
                        label = el['name'] + ' ' + el['last_name'];
                    }
                    return {
                        id: el.id,
                        label: label,
                        value: label
                    };
                });

            }
            if(user_action && this.selectedFilters && this.selectedFilters[row_index] && this.selectedFilters[row_index].cols){
                let f_index = this.selectedFilters[row_index].cols.findIndex(el=>el.type == 'value');
                if(f_index != -1){
                    this.selectedFilters[row_index].cols.splice(f_index, 1);
                }
            }
            // let selected_filter_value_index = this.selectedFilters && this.selectedFilters[row_index] && this.selectedFilters[row_index].cols ? this.selectedFilters[row_index].cols.findIndex(el => el.type == 'value') : -1;
            // if (selected_filter_value_index != -1)
            //     this.$set(this.selectedFilters[row_index].cols[selected_filter_value_index],'selectedOption',[]);
            this.$set(this.columns[value_index].options,row_index,mapped_users);
        },
        async getFilterData(row_index, initial) {
            let filter_index = this.selectedFilters[row_index].cols.findIndex(el => el.type == 'key');
            
            if (filter_index != -1) {
                let filter_value = this.selectedFilters[row_index].cols[filter_index].selectedOption[0].value;
                let index = -1
                if(this.initial_cols)
                    index = this.initial_cols.findIndex(el => el.value == filter_value);
                if (!initial) {
                    let selected_filter_value_index = this.selectedFilters && this.selectedFilters[row_index] && this.selectedFilters[row_index].cols ? this.selectedFilters[row_index].cols.findIndex(el => el.type == 'value') : -1;
                    if (selected_filter_value_index != -1)
                        this.$set(this.selectedFilters[row_index].cols[selected_filter_value_index], 'selectedOption', []);
                    let selected_filter_condition_index = this.selectedFilters && this.selectedFilters[row_index] && this.selectedFilters[row_index].cols ? this.selectedFilters[row_index].cols.findIndex(el => el.type == 'condition') : -1;
                    if (selected_filter_condition_index != -1) {
                        let column_options = this.columns.find(el => el.type == 'condition');
                        if (column_options) {
                            column_options= column_options.options
                            let selected_option_type = this.selectedFilters[row_index].cols[filter_index].selectedOption[0].type;
                            let selected_option_conditions = this.selectedFilters[row_index].cols[filter_index].selectedOption[0].conditions;
                            let selected_option = null;
                            if(selected_option_conditions){
                                selected_option = column_options.filter(el => selected_option_conditions.includes(el.value))[0];
                            }
                            else selected_option = column_options.filter(el => el.type == selected_option_type)[0];
                            this.$set(this.selectedFilters[row_index].cols[selected_filter_condition_index], 'selectedOption', [selected_option]);
                        }
                    }
                }
                if (index != -1) {
                    let data = await this.initial_cols[index].data(this.initial_cols[index]);
                    if (this.initial_cols[index].multiselect != undefined) {
                        if(!this.columns[3].multiselect) this.$set(this.columns[3],'multiselect', [])
                        this.$set(this.columns[3].multiselect, row_index, this.initial_cols[index].multiselect);
                    }
                    this.$set(this.columns[3].options, row_index, data);
                }
                if(filter_value == "training_not_finished"){
                     let value_index = this.selectedFilters[row_index].cols.findIndex(el => el.type == 'value');
                    if(this.trainings.length == 0 || this.columns[value_index].options[row_index].length == 0)
                        await this.loadAllTrainings();
                    this.$set(this.columns[value_index].options, row_index, this.trainings);
                }
            }
        },
        uniq(a) {
            var prims = {"boolean":{}, "number":{}, "string":{}}, objs = [];

            return a.filter(function(item) {
                var type = typeof item;
                if(type in prims)
                    return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
                else
                    return objs.indexOf(item) >= 0 ? false : objs.push(item);
            });
        },
        getSelectedItems(row_index, col){
            let col_id =col
            if(this.selectedFilters[row_index] && this.selectedFilters[row_index].cols){
                let index = this.selectedFilters[row_index].cols.findIndex(el=>el.id == col_id);
                if(index != -1){
                    if(this.selectedFilters[row_index].cols[index].selectedOption != null){
                        return this.selectedFilters[row_index].cols[index].selectedOption
                    }
                    else return [];
                }
            }
            return [];
        },
        getSelectedSubItems(row_index, col=4) {
             let col_id =col
            if(this.selectedFilters[row_index] && this.selectedFilters[row_index].cols){
                let index = this.selectedFilters[row_index].cols.findIndex(el=>el.id == col_id);
                if(index != -1){
                    if(this.selectedFilters[row_index].cols[index].selectedSubOption != null){
                        return this.selectedFilters[row_index].cols[index].selectedSubOption
                    }
                    else return [];
                }
            }
            return [];
        },
        getFilterOptions(row_index, column){
            if(column.type == 'condition'){
                let index = this.selectedFilters[row_index].cols.findIndex(el => el.id == 2);
                if (this.selectedFilters[row_index].cols[index] && this.selectedFilters[row_index].cols[index].selectedOption && this.selectedFilters[row_index].cols[index].selectedOption[0]) {
                    let selected_option = this.selectedFilters[row_index].cols[index].selectedOption[0];
                    if(selected_option.conditions){
                        return column.options.filter(el=>selected_option.conditions.includes(el.value))
                    }
                }
                if(this.selectedFilters[row_index].cols[index] && this.selectedFilters[row_index].cols[index].selectedOption && this.selectedFilters[row_index].cols[index].selectedOption[0] && this.selectedFilters[row_index].cols[index].selectedOption[0].type == 'number'){
                    return column.options.filter(el=>el.type == 'number')
                }
                else{
                    return column.options.filter(el=>el.type == 'text')
                }
            }
            else if(column.type == 'value'){
                return column.options[row_index] ? column.options[row_index] : []
            }
            return column.options
        },
        renderFilterInput(row_index, column){
            
            if(column.type == 'value'){
                if(this.selectedFilters[row_index]){
                    let index = this.selectedFilters[row_index].cols.findIndex(el => el.id == 2);
                    if(index != -1){
                        // if (this.selectedFilters[row_index].cols[index].selectedOption[0] && ['number','timeframe'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].type)){
                        //     return true;
                        // } 
                        if (this.selectedFilters[row_index].cols[index].selectedOption[0] && ['number'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].type)){
                            return true;
                        }
                        if(this.selectedFilters[row_index].cols[index].selectedOption[0] && ['penalty'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].value)){
                            return false;
                        }
                        if(this.selectedFilters[row_index].cols[index].selectedOption[0] && ['time'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].value)){
                            return true
                        }
                    
                    }
                    index = this.selectedFilters[row_index].cols.findIndex(el => el.id == 3);
                    if(index != -1){
                        if( this.selectedFilters[row_index].cols[index].selectedOption[0] && ['includes', 'excludes'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].value)){
                            return true
                        }
                    }
                    
                }
            }
           
            return false;
        },
        renderInput(row_index, column){
            if(column.type == 'value' || column.type == 'timeframe_type' || column.type == 'assign_timing'){
                if(this.selectedFilters[row_index]){
                    let index = this.selectedFilters[row_index].cols.findIndex(el => el.id == 2);
                    if(index != -1){
                        if (this.selectedFilters[row_index].cols[index].selectedOption[0] && ['training_not_finished'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].value)){
                            if(column.type == 'value'){
                                index = this.selectedFilters[row_index].cols.findIndex(el => el.id == 5);
                                if(index != -1){
                                    if (this.selectedFilters[row_index].cols[index].selectedOption[0] && !['in_timeframe'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].value)){
                                        return false;
                                    }
                                }
                            }
                            return true;
                        }
                    }
                }
            }
           
            return false;
        },
        async loadViolationTypes(){
            try {
                const response = await axios.get(
                    `${this.$store.state.api_link}/user/violations`, 
                    this.$store.getters.axiosConfig()
                );
                
                this.violations = response.data.violation_types;
                return this.violations;
            } catch (error) {
                this.$store.commit("handleError", {"error": error});
                return [];
            }
        },
        showDropdown(row_index, column){
            if(column && ['additional_value','timeframe_type', 'timeframe_period', 'timeframe_text', 'assign_timing', 'assign_timing_text', 'assign_timing_period'].includes(column.type)){
                if(this.selectedFilters[row_index]){
                    let index = this.selectedFilters[row_index].cols.findIndex(el => el.id == 2);
                    if(index != -1){
                         if(['timeframe_type', 'timeframe_period', 'timeframe_text', 'assign_timing', 'assign_timing_text', 'assign_timing_period'].includes(column.type)){
                            let duplicate_rows = false;
                            this.selectedFilters.slice(0,row_index).forEach((row_el, r_index) => {
                                let index = row_el.cols.findIndex(el => el.id == 2);
                                if(index != -1){
                                    if (row_el.cols[index].selectedOption[0] && ['training_not_finished'].includes(row_el.cols[index].selectedOption[0].value) && (row_index != r_index)){
                                        duplicate_rows = true;
                                    }
                                }
                            });
                            if(duplicate_rows){
                                return false
                            }
                        }
                        // if(['assign_timing', 'assign_timing_text', 'assign_timing_period'].includes(column.type)){
                        //     if(['assign_timing_text', 'assign_timing_period'].includes(column.type)){
                        //         let timing_index = this.selectedFilters[row_index].cols.findIndex(el => el.id == 8);
                        //         if(timing_index != -1){
                        //             if(this.selectedFilters[row_index].cols[timing_index].selectedOption[0] && ['now'].includes(this.selectedFilters[row_index].cols[timing_index].selectedOption[0].value)){
                        //                 return false;
                        //             }
                        //         }
                        //     }
                        //     if(this.selectedFilters[row_index].cols[index].selectedOption[0] && ['training_not_finished'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].value)){
                        //         return true
                        //     }
                        // }
                       
                        // if(['timeframe_period', 'timeframe_text'].includes(column.type)){
                        //     let timing_index = this.selectedFilters[row_index].cols.findIndex(el => el.id == 5);
                        //     if(timing_index != -1){
                        //         if(this.selectedFilters[row_index].cols[timing_index].selectedOption[0] && ['now'].includes(this.selectedFilters[row_index].cols[timing_index].selectedOption[0].value)){
                        //             return false;
                        //         }
                        //     }
                        // }
                        if(['additional_value'].includes(column.type)){
                            if(this.selectedFilters[row_index].cols[index].selectedOption[0] && ['penalty'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].value)){
                                return true
                            }
                            else{
                                return false;
                            }
                        }
                        if (this.selectedFilters[row_index].cols[index].selectedOption[0] && ['training_not_finished'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].value)){
                            if(['timeframe_period', 'timeframe_text'].includes(column.type)){
                                index = this.selectedFilters[row_index].cols.findIndex(el => el.id == 5);
                                if(index != -1){
                                    if (this.selectedFilters[row_index].cols[index].selectedOption[0] && !['in_timeframe'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].value)){
                                        return false;
                                    }
                                }
                            }
                            return true;
                        }
                    }
                    
                   
                }
                return false;
            }
       
            if(column && column.type == 'condition'){
                  if(this.selectedFilters[row_index]){
                    let index = this.selectedFilters[row_index].cols.findIndex(el => el.id == 2);
                    if(index != -1){
                        if (this.selectedFilters[row_index].cols[index].selectedOption[0] && ['training_not_finished'].includes(this.selectedFilters[row_index].cols[index].selectedOption[0].value)){
                            return false
                        }
                    }
                   
                }
                return true;
            }
           
            return true;
        },
        getSelectedColumnType(row_index, column) {
            if(column.type == 'value'){
                if(this.selectedFilters[row_index]){
                    let index = this.selectedFilters[row_index].cols.findIndex(el => el.id == 2);
                    if (index != -1) {
                        return this.selectedFilters[row_index].cols[index].selectedOption[0].type
                    }
                }
            }
            return ''
        },
        getItemPlaceholder(row_index, col){
            let col_id = col.id;
            if(this.selectedFilters[row_index] && this.selectedFilters[row_index].cols){
                let index = this.selectedFilters[row_index].cols.findIndex(el=>el.id == col_id);
                let option = this.selectedFilters[row_index].cols[index] ? this.selectedFilters[row_index].cols[index].selectedOption : [];
                // if(index !== -1 && option.length > 0){
                //     let placeholder = '';
                //     for(let i = 0; i < option.length; i++){
                //         placeholder += option && option[i] ? option[i].label : '';
                //         if(this.selectedFilters[row_index].cols[index].selectedOption[i+1]){
                //             placeholder += ', ';
                //         }
                //     }
                //     return placeholder;
                // }
                if(index !== -1 && option.length == 1){
                    return option && option[0].label ? option[0].label : '';
                }else if(index !== -1 && option.length > 0){
                    return this.toLocal('assign_modal.multiple_values');
                }
            }
            return col.placeholder;
        },
        getSubItemPlaceholder(row_index, col) {
             let col_id = col.id;
            if(this.selectedFilters[row_index] && this.selectedFilters[row_index].cols){
                let index = this.selectedFilters[row_index].cols.findIndex(el=>el.id == col_id);
                let option = this.selectedFilters[row_index].cols[index] && this.selectedFilters[row_index].cols[index].selectedSubOption ? this.selectedFilters[row_index].cols[index].selectedSubOption : [];
                if (index !== -1 && option && option.length == 1) {
                    return option && option[0].label ? option[0].label : '';
                }else if(index !== -1 && option && option.length > 0){
                    return this.toLocal('assign_modal.multiple_values');
                }
            }
            return col.placeholder;
        },
        removeFilterRow(row_index){
            this.selectedFilters.splice(row_index, 1);
        },
        addNewFilterRow(){
            this.selectedFilters.push({
                cols: [
                    {
                        id: 1,
                        type: this.columns[0].type,
                        selectedOption: [this.columns[0].options[0]]
                    },
                ],
            });
        },
        copyFilterRow(index){
            let row = this.selectedFilters[index];
            this.selectedFilters.splice(index, 0, row)
        },
        setFilterTextInput(e, row_index, column_id){
            let col_index = this.selectedFilters[row_index].cols.findIndex(el=>el.id == column_id);
            let column = this.columns.find(el=>el.id == column_id);
            if(column.inputFormat == 'number'){
                this.textInputs[`${row_index}-${column_id}`] = e.target.value.replace(/\D/g, '')

            }
            let select_option =[
                {id: 1, type: 'text', value: this.textInputs[`${row_index}-${column_id}`]}
            ];
            if(col_index != -1){
                this.selectedFilters[row_index].cols[col_index].selectedOption = select_option
            }
            else{
                let column = this.columns.find(el=>el.id == column_id);
                this.selectedFilters[row_index].cols.push({
                    id: column_id,
                    type: column.type,
                    selectedOption: select_option
                })
            }

        },
        checkIfInputAllowed(e, row_index, column) {
            if(column && column.inputFormat == 'number'){
                const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                const keyPressed = e.key;

                if (!keysAllowed.includes(keyPressed)) {
                    e.preventDefault()
                }

            }
            else{
                let key_option = this.selectedFilters[row_index].cols.findIndex((el) => el.id == 2);
                if(key_option != -1){
                    key_option = this.selectedFilters[row_index].cols[key_option].selectedOption[0];
                    let key_option_type = key_option.type;
                    if (key_option_type == 'number') {
                        const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                        const keyPressed = e.key;

                        if (!keysAllowed.includes(keyPressed)) {
                            e.preventDefault()
                        }
                    }
                }
            }
           
        },
        async loadAllTrainings() {
            try {
            const response = await axios.get(
                    `${this.$store.state.api_link}/training/trainings`, 
                    this.$store.getters.axiosConfig()
                );
                
                this.trainings = response.data.data;
                this.trainings.forEach(el => {
                    el.data = JSON.parse(el.data);
                    el['title'] = el.data.title
                });
                this.trainings.sort((a, b) => {
                    if (a.title.localeCompare(b.title) < 0) return -1;
                    else return 1;
                });

                return this.trainings;
            } catch (error) {
                this.$store.commit("handleError", {"error": error});
                return [];
            }
        },
        
    }
}
</script>

<style lang="scss" scoped>
.condition-wrapper{
    display: flex;
    flex-direction: column;
    &.filter-training-users{
        .add-new-row{
            margin-top: 20px;
        }
        .dropdown-container {
            background: white;
        }
        .first-row,.additional-row{
            position: relative;
            padding: 20px 12px;
            border-radius: 8px;
            background: #F4F4F4;
            box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.20);
        }
        .filter-training-users-row{
            flex-direction: column;
            align-items: flex-start;

        }
        .additional-row-container{
            margin:0;
        }
        .additional-row{
            border-top-left-radius: 0;
            margin-top: 40px;
            
        }
        .logical-condition{
            position: absolute;
            top: -28px;
            left: 0;
            background: #4D4D4D;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            border:none;
            color: white;
            .dropdown-initial{
                color: white;
                span{
                    color: white;

                }
            }
            svg{
                path{
                    stroke: white;
                }
            }
            &::before{
                content: '';
                position: absolute;
                left: 19px;
                top: -23px;
                height: 23px;
                z-index: -1;
                background: #7D7D7D;
                width: 1px;
            }
        }
    }
}
.checkbox-container{
    margin-top: 0.5rem;
}
.tools-container{
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    color: #333;
    text-overflow: ellipsis;
    font-family: var(--main-site-font);
    font-size: 14px;
    font-weight: 500;
    .first-row-add-label{
    }
    button{
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 8px 12px;
        border: none;
        border-radius: 30px;
        background: #E2E2E2;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.20);
        svg{
            margin-left: 8px;
        }
    }
}
.options{
    position: absolute;
    right: 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    .option-btn{
        display: flex;
        align-items: center;
        cursor: pointer;
    }
}
.first-row{
    display: flex;
}
.additional-row{
    display: flex;
    align-items: center;
    gap: 12px;
    
}
.additional-row-container{
    display: flex;
    flex-direction: column;
    margin: 12px 0;
    gap: 12px;
}
.first-row-add-label{
    display: flex;
    align-items: center;
    margin-right: 22px;
}
.dropdown-list-container{
    display: flex;
    align-items: center;
    gap: 12px;
}

.filter-item{
    display: flex;
    align-items: center;
    gap: 12px;
}
.assign-label{
    font-size: 14px;
    font-family: var(--main-site-font);
}
.add-new-row{
    display: flex;
    align-items: center;
    color: #7D7D7D;
    text-overflow: ellipsis;
    font-family: var(--main-site-font);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    cursor: pointer;
    svg{
        margin-right: 4px;
    }
    &.white-btn{
        background-color: white;
        padding: 4px;
        width: fit-content;
        border-radius: 6px;
        &:hover{
            color: #333;
            svg{
                path{
                    stroke:#333
                }
            }
        }
    }
}
.remove-filter-btn{
    cursor: pointer;
    user-select: none;
}
input{
    background: #FFF;
    color: #333;
    text-overflow: ellipsis;
    font-family: var(--main-site-font);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    border-radius: 6px;
    border: 1px solid #B2B2B2;
    padding: 4px 10px;
}
.right-side{
    display: flex;
    align-items: center;
    gap: 12px;
}
.filter-tag-list{
    display: flex;
    gap: 8px;
    .hide-box{
        max-width: 375px;
        overflow-x: hidden;
    }
    .fixed-box{
        overflow-x: hidden;
        display: flex;
        gap: 8px;
        overflow: hidden;

        position: relative;
        flex-wrap: wrap;
        max-height: 64px;
        max-width: 400px;
        .tag{
            display: flex;
            gap: 12px;
            padding: 4px 8px;
            border-radius: 4px;
            background: #E2E2E2; 
            justify-content: center;
            align-items: center;
            flex-basis: 50px;
            .text{
                font-size: clamp(12px, 1.5vw, 14px);
                white-space: nowrap;
            }
            .tag-delete{
                font-size: clamp(12px, 1.5vw, 14px);
                svg{
                    transition: 0.25s;
                }
                &:hover{
                    cursor: pointer;
                    svg{
                        path{
                            fill: black;
                        }
                    }
                }
            }
        }
        .more-options{
            display: inline-flex;
            padding: 2px 8px;
            align-items: center;
            border-radius: 4px;
            background: #E2E2E2; 
        }
    }
}
.short-input{
    max-width: 2.7rem;
}
</style>
<style lang="scss">
.condition-filter-dropdown{
    border-radius: 6px;
    border: 1px solid #B2B2B2;
    &.dropdown-container{
        background: #FFF;
        color: #333;
        text-overflow: ellipsis;
        font-family: var(--main-site-font);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
      
        .dropdown-initial{
            span{
                max-width: 100%;
            }
        }
        &:not(.no-padding-no-bg){
            background: none;
        }
        &.whiteContrast{
    
            .checkmark{
                path{
                fill: inherit;
                stroke: white
                }
            }
        }
    }
}
.filter-training-users{
    .logical-condition{
        .dropdown-initial{
            color: white;
           
        }
    }
}
.conditional-time-date-picker{
    &.mx-datepicker{
        width: 5.5rem;
        height: 30px;
        .mx-input{
            height: 30px;
            border: 1px solid #B2B2B2;
            box-shadow: none;
            color: #333;
        }
    }
}
</style>